var _style, _g, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuizBreakBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_3",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1377D4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.682,10.028C1.96,8.562,2.541,7.205,3.361,6.022C3.06,5.729,2.76,5.437,2.46,5.143   c-1.03,1.429-1.742,3.096-2.044,4.904C0.853,10.04,1.276,10.034,1.682,10.028z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.316,2.331C5.635,2.64,5.936,2.932,6.232,3.22c1.12-0.738,2.389-1.267,3.752-1.531V0.426   C8.273,0.721,6.689,1.379,5.316,2.331z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.995,22.28c-1.398-0.27-2.699-0.814-3.841-1.58l-0.894,0.894c1.389,0.975,2.997,1.651,4.736,1.949V22.28z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.696,14.03c-0.422,0.006-0.839,0.012-1.26,0.018c0.31,1.738,1.001,3.342,1.987,4.726l0.892-0.892   C2.534,16.739,1.975,15.435,1.696,14.03z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.983,0.426v1.263c4.831,0.937,8.491,5.194,8.491,10.295c0,5.097-3.654,9.352-8.479,10.293v1.263   c5.517-0.958,9.729-5.769,9.729-11.556C23.725,6.192,19.507,1.379,13.983,0.426z",
    fill: "#000000"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.199,16.672 11.21,12.417 11.21,3.944 12.71,3.944 12.71,11.574 18.979,15.391 ",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuizBreakBlue);
export default __webpack_public_path__ + "static/media/icon-quiz-break-blue.be0664e66399f60f8446db1562dc86f7.svg";
export { ForwardRef as ReactComponent };